import { percent } from 'csx'
import { style } from 'typestyle'
import prop from 'vue-strict-prop'
import { component } from 'vue-tsx-support'

import LoadingScreen from '@/components/LoadingScreen'

export default component({
	name: 'App',
	props: {
		loading: prop(Boolean).required,
	},
	render() {
		return this.loading ?
			<LoadingScreen />
			:
			<router-view class={['ui container', styleRouterView]} />
	},
})

const styleRouterView = style({
	minWidth: percent(93),
})
